<script lang="ts">
  import Icon from '@iconify/svelte'
  import type { Props } from './article.types'

  const { image, title, description, href }: Props = $props()
</script>

<div
  class="article | group/article relative w-full cursor-default overflow-hidden rounded-xl transition"
>
  <div
    class="article__content | relative z-10 flex size-full min-h-[180px] flex-col items-start p-4 backdrop-blur-md"
  >
    {#if image}
      <div
        class="article__figure | mb-4 flex h-[280px] w-full items-center overflow-hidden rounded-lg bg-gray-200 text-brand/50 group-hover/article:text-brand"
      >
        <img class="h-full w-full object-cover" src={image} alt={title} />
      </div>
    {:else}
      <div
        class="article__figure | mb-4 flex min-h-[280px] w-full items-center justify-center rounded-lg bg-brand-500/20 text-brand/50 group-hover/article:text-brand"
      >
        <Icon class="text-8xl" icon="solar:chat-dots-bold-duotone" />
      </div>
    {/if}

    <h3 class="article__title | mb-2 h-[56px] text-lg font-medium sm:text-lg">
      <span class="text-brand-600 group-hover/article:text-brand">{title}</span>
    </h3>

    <p
      class="article__description | min-h-[96px] text-pretty text-sm font-medium text-gray-600 transition group-hover/article:text-gray-900"
    >
      {description}
    </p>

    <a class="flex w-auto justify-start rounded-lg text-brand-500 underline" target="_blank" {href}>
      Ver mais...
    </a>
  </div>

  <a {href} class="absolute left-0 top-0 z-10 h-full w-full" target="_blank">
    <span class="sr-only">{title}</span>
  </a>
</div>
